import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { buildLocale } from '../../lib/build-locale';
import { getFullPath } from '../../lib/get-full-path';
import { extractLocaleFromPath, getPathLanguage, getPathLocation } from '../../lib/locale-extract';
import { localeToPathPrefix } from '../../pipes/translate-link.pipe';
import { RedirectService } from '../../services/redirect.service';

export const defaultLocaleGuard: CanActivateFn = route => {
  const redirectService = inject(RedirectService);
  const path = getFullPath(route, false, false);
  const language = getPathLanguage(path);
  const location = getPathLocation(path);
  const expectedPrefix = localeToPathPrefix(buildLocale(language, location));
  const prefix = extractLocaleFromPath(path)?.toLowerCase() || '';
  const prefixFromPath = path[0];

  if (prefix === expectedPrefix && prefixFromPath === expectedPrefix) {
    return true;
  }

  const pathWithoutLocale = getFullPath(route);

  return redirectService.redirectTo(['/' + expectedPrefix, ...pathWithoutLocale]);
};
